import { render, staticRenderFns } from "./ex-area-list.vue?vue&type=template&id=35b0d1f1&scoped=true&"
import script from "./ex-area-list.vue?vue&type=script&lang=js&"
export * from "./ex-area-list.vue?vue&type=script&lang=js&"
import style0 from "./ex-area-list.vue?vue&type=style&index=0&id=35b0d1f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b0d1f1",
  null
  
)

export default component.exports